import AppIcon from '@components/AppIcon';
import MainLayout from '@layouts/MainLayout';

Vue.component('app-icon', AppIcon);
Vue.component('main-layout', MainLayout);
